/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Status_At_WarehouseInputs */

const en_sync_status_at_warehouse = /** @type {(inputs: Sync_Status_At_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the warehouse`)
};

/**
* | output |
* | --- |
* | "At the warehouse" |
*
* @param {Sync_Status_At_WarehouseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_status_at_warehouse = /** @type {((inputs?: Sync_Status_At_WarehouseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Status_At_WarehouseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_status_at_warehouse(inputs)
});